 
// import React, { useState, useEffect } from "react";
 
// import {
//   FileText,
//   Clock3,
//   Target,
//   AlertTriangle,
//   Sparkles,
//   TrendingUp,
// } from "lucide-react";
 
// import { useTheme } from "../css/ThemeContext";
// import "./TheoryAnalytics.css";
 
// const TheoryAnalytics = () => {
 
//   const { theme, generateGradient } = useTheme();
 
//   const appGradient = generateGradient(
//     theme.appGradient.start,
//     theme.appGradient.end
//   );
 
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
 
//   const [selectedExamData, setSelectedExamData] = useState(null);
//   const [dropdownExams, setDropdownExams] = useState([]);
//   const [topicMastery, setTopicMastery] = useState([]);
 
//   const [strength, setStrength] = useState("");
//   const [weakness, setWeakness] = useState(null);
 
//   const [selectedExamId, setSelectedExamId] = useState(null);
 
//   // ================= FORMAT TIME =================
 
//   const formatTime = (seconds) => {
//     if (!seconds) return "0m 0s";
 
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
 
//     return `${mins}m ${secs}s`;
//   };
 
//   // ================= FETCH API =================
 
//   const fetchAnalytics = async (examId = null) => {
 
//     setLoading(true);
//     setError(null);
 
//     try {
 
//       let url = "/dashboard/theory-analytics/";
 
//       if (examId) {
//         url += `?exam_employee_id=${examId}`;
//       }
 
//       const response = await fetch(url, {
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
 
//       if (!response.ok) {
 
//         const err = await response.json();
 
//         throw new Error(
//           err.error || "Failed to fetch analytics"
//         );
//       }
 
//       const data = await response.json();
 
//       setSelectedExamData(data.selectedExam);
 
//       setDropdownExams(data.dropdown_exams || []);
 
//       setTopicMastery(data.topicMastery || []);
 
//       setStrength(data.strength || "");
 
//       setWeakness(data.weakness);
 
//       // sync dropdown
//       if (!examId && data.selectedExam?.exam_employee_id) {
 
//         setSelectedExamId(
//           data.selectedExam.exam_employee_id
//         );
 
//       } else if (examId) {
 
//         setSelectedExamId(examId);
//       }
 
//     } catch (err) {
 
//       console.error("ObjectiveAnalytics fetch error:", err);
 
//       setError(err.message);
 
//     } finally {
 
//       setLoading(false);
//     }
//   };
 
//   // ================= INITIAL LOAD =================
 
//   useEffect(() => {
//     fetchAnalytics();
//   }, []);
 
//   // ================= DROPDOWN =================
 
//   const handleExamChange = (e) => {
 
//     const newExamId = e.target.value;
 
//     if (newExamId) {
//       fetchAnalytics(newExamId);
//     }
//   };
 
//   // ================= LOADING =================
 
//   if (loading) {
//     return (
//       <div
//         style={{
//           textAlign: "center",
//           padding: "40px",
//         }}
//       >
//         Loading analytics...
//       </div>
//     );
//   }
 
//   // ================= ERROR =================
 
//   if (error) {
//     return (
//       <div
//         style={{
//           textAlign: "center",
//           padding: "40px",
//           color: "red",
//         }}
//       >
//         Error: {error}
//       </div>
//     );
//   }
 
//   // ================= NO DATA =================
 
//   if (!selectedExamData) {
//     return (
//       <div
//         style={{
//           textAlign: "center",
//           padding: "40px",
//         }}
//       >
//         No Objective exam data available.
//       </div>
//     );
//   }
 
//   // ================= SCORE =================
 
//   const accuracy = selectedExamData.accuracy || 0;
 
//   const circumference = 2 * Math.PI * 42;
 
//   const strokeDashoffset =
//     circumference * (1 - accuracy / 100);
 
//   // ================= RESULT =================
 
//   const resultText =
//     selectedExamData.is_passed
//       ? "Passed"
//       : "Not passed";
 
//   const resultColor =
//     selectedExamData.is_passed
//       ? "#22c55e"
//       : "#ef4444";
 
//   // ================= DYNAMIC HEADER =================
 
//   let dynamicTitle = "";
//   let dynamicMessage = "";
 
//   // EXCELLENT
//   if (accuracy >= 90) {
 
//     dynamicTitle = "Outstanding performance 🚀";
 
//     dynamicMessage =
//       "Excellent work! Your accuracy and consistency are impressive.";
//   }
 
//   // VERY GOOD
//   else if (accuracy >= 75) {
 
//     dynamicTitle = "Great job 👏";
 
//     dynamicMessage =
//       "You're performing really well. A little more practice can make it perfect.";
//   }
 
//   // GOOD
//   else if (accuracy >= 60) {
 
//     dynamicTitle = "Good progress 📈";
 
//     dynamicMessage =
//       "You have a solid understanding. Focus on weaker areas to improve further.";
//   }
 
//   // AVERAGE
//   else if (accuracy >= 40) {
 
//     dynamicTitle = "Keep improving 💡";
 
//     dynamicMessage =
//       "You're getting there. More focused revision will boost your score.";
//   }
 
//   // LOW
//   else {
 
//     dynamicTitle = "Let's level up 🔥";
 
//     dynamicMessage =
//       "A focused review and consistent practice will turn this around quickly.";
//   }
 
//   // ================= FALLBACK STRENGTH =================
 
//   let fallbackStrength = "";
//   let fallbackWeakness = "";
 
//   // EXCELLENT
//   if (accuracy >= 90) {
 
//     fallbackStrength =
//       "Excellent performance with strong conceptual understanding and accuracy.";
 
//     fallbackWeakness =
//       "Very minor improvements needed — focus on maintaining this consistency.";
//   }
 
//   // VERY GOOD
//   else if (accuracy >= 75) {
 
//     fallbackStrength =
//       "Strong overall performance with good accuracy across most topics.";
 
//     fallbackWeakness =
//       "A little more attention to tricky questions can further improve results.";
//   }
 
//   // GOOD
//   else if (accuracy >= 60) {
 
//     fallbackStrength =
//       "Good understanding of core concepts and steady performance.";
 
//     fallbackWeakness =
//       "Focus more on weak areas and accuracy under challenging questions.";
//   }
 
//   // AVERAGE
//   else if (accuracy >= 40) {
 
//     fallbackStrength =
//       "You have started building a solid foundation in the subject.";
 
//     fallbackWeakness =
//       "More revision and practice are needed to improve confidence and accuracy.";
//   }
 
//   // LOW
//   else {
 
//     fallbackStrength =
//       "Good effort in attempting the assessment and engaging with the questions.";
 
//     fallbackWeakness =
//       "Focus on understanding the basics and revisit important concepts carefully.";
//   }
 
//   return (
 
//     <div
//       className="theory-analytics-wrapper"
//       style={{
//         "--app-gradient": appGradient,
//       }}
//     >
 
//       {/* ================= HEADER ================= */}
 
//       <div className="gradient-header">
 
//         {/* LEFT SIDE */}
 
//         <div className="header-left">
 
//           <div className="small-text">
//             {selectedExamData.title}
//           </div>
 
//           <h2>
//             {dynamicTitle}
//           </h2>
 
//           <p>
//             {selectedExamData.user_name} · {dynamicMessage}
//           </p>
 
//           {/* ================= PILLS ================= */}
 
//           <div className="pill-row">
 
//             <span className="pill">
//               <FileText size={15} />
//               {selectedExamData.attempted_count}/
//               {selectedExamData.question_count} Attempted
//             </span>
 
//             <span className="pill">
//               <Clock3 size={15} />
//               {formatTime(
//                 selectedExamData.time_taken_seconds
//               )}
//             </span>
 
//             <span className="pill green">
//               <Target size={15} />
//               {selectedExamData.correct_count} Correct
//             </span>
 
//             <span className="pill red">
//               <AlertTriangle size={15} />
//               {selectedExamData.wrong_count} Wrong
//             </span>
 
//           </div>
//         </div>
 
//         {/* ================= RIGHT SIDE ================= */}
 
//         <div className="header-right">
 
//           {/* DROPDOWN */}
 
//           <select
//             className="exam-dropdown"
//             value={selectedExamId || ""}
//             onChange={handleExamChange}
//           >
 
//             {dropdownExams.map((exam) => (
 
//               <option
//                 key={exam.value}
//                 value={exam.value}
//               >
//                 {exam.label}
//               </option>
 
//             ))}
 
//           </select>
 
//           {/* SCORE + RESULT */}
 
//           <div className="score-result-container">
 
//             {/* SCORE */}
 
//             <div className="score-circle">
 
//               <svg
//                 viewBox="0 0 100 100"
//                 className="circle-svg"
//               >
 
//                 <circle
//                   cx="50"
//                   cy="50"
//                   r="42"
//                   className="circle-bg"
//                 />
 
//                 <circle
//                   cx="50"
//                   cy="50"
//                   r="42"
//                   className="circle-progress"
//                   style={{
//                     strokeDasharray: circumference,
//                     strokeDashoffset:
//                       strokeDashoffset,
//                   }}
//                 />
 
//               </svg>
 
//               <div className="circle-content">
 
//                 <div>
//                   {accuracy}%
//                 </div>
 
//                 <div className="label">
//                   ACCURACY
//                 </div>
 
//               </div>
//             </div>
 
//             {/* RESULT */}
 
//             <div className="result-block">
 
//               <div className="small-text">
//                 Result:
//               </div>
 
//               <div
//                 className="result-text"
//                 style={{
//                   color: resultColor,
//                 }}
//               >
//                 {resultText}
//               </div>
 
//               <div className="small-text">
 
//                 Threshold :
//                 {" "}
//                 {selectedExamData.required_percent}%
//                 required
 
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
 
//       {/* ================= TOPIC MASTERY ================= */}
 
//       <div className="topic-card">
 
//         <div className="topic-header">
 
//           <h3>
//             Areas to improve
//           </h3>
 
//           <p>
//             Focus on these topics to improve your next Objective Performance
//           </p>
 
//         </div>
 
//         <div className="topic-list">
 
//           {topicMastery.length === 0 ? (
 
//             <div className="all-mastered-card">
//               🎉 Excellent work! You have mastered all topics in this assessment.
//             </div>
 
//           ) : (
 
//             topicMastery.map((topic, idx) => {
 
//               const percent = Math.round(
//                 (topic.correct / topic.total) * 100
//               );
 
//               const color =
//                 percent >= 80
//                   ? "#22c55e"
//                   : percent >= 50
//                     ? "#f59e0b"
//                     : "#ef4444";
 
//               return (
 
//                 <div
//                   key={idx}
//                   className="topic-item"
//                 >
 
//                   <div className="topic-row">
 
//                     <span className="topic-name">
//                       {topic.name}
//                     </span>
 
//                     <span
//                       className="topic-badge"
//                       style={{
//                         background: `${color}22`,
//                         color,
//                       }}
//                     >
//                       {percent}%
//                     </span>
 
//                   </div>
 
//                   <div className="topic-meta">
 
//                     {topic.correct}/{topic.total}
//                     {" "}
//                     questions correct
 
 
 
//                   </div>
 
//                   <div className="topic-advanced-progress">
 
//                     {/* LEFT SIDE */}
//                     {/* <div className="topic-progress-left">
 
//                     <div
//                       className="topic-ring"
//                       style={{
//                         "--topic-color": color,
//                         "--topic-percent": `${percent}%`,
//                       }}
//                     >
//                       <div className="topic-ring-inner">
//                         {percent}%
//                       </div>
//                     </div>
 
//                   </div> */}
 
//                     {/* RIGHT SIDE */}
 
 
 
 
//                     <div className="topic-performance-bar">
 
//                       <div
//                         className="topic-performance-fill"
//                         style={{
//                           width: `${percent}%`,
//                           background: `linear-gradient(90deg, ${color}, ${color}cc)`,
//                         }}
//                       />
 
//                     </div>
 
 
//                   </div>
//                 </div>
//               );
//             })
//           )}
//         </div>
//       </div>
 
//       {/* ================= INSIGHTS ================= */}
 
//       <div className="insight-grid">
 
//         {/* STRENGTH */}
 
//         <div
//           className="summary-card"
//           style={{
//             background: "#e6f7ee",
//             border: "1px solid #bbf7d0",
//           }}
//         >
 
//           <div className="summary-icon strength-icon">
//             <Sparkles size={18} />
//           </div>
 
//           <div>
 
//             <div className="summary-title">
//               What you did well
//             </div>
 
//             <div
//               className="summary-text"
//               style={{
//                 color: "#065f46",
//               }}
//             >
//               {strength || fallbackStrength}
//             </div>
 
//           </div>
//         </div>
 
//         {/* WEAKNESS */}
 
//         <div
//           className="summary-card"
//           style={{
//             background: "#f5f3ff",
//             border: "1px solid #e9d5ff",
//           }}
//         >
 
//           <div className="summary-icon weakness-icon">
//             <TrendingUp size={18} />
//           </div>
 
//           <div>
 
//             <div className="summary-title">
//               Where to grow
//             </div>
 
//             <div
//               className="summary-text"
//               style={{
//                 color: "#6b21a8",
//               }}
//             >
//               {weakness || fallbackWeakness}
//             </div>
 
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
 
// export default TheoryAnalytics;
 

import React, { useState, useEffect } from "react";
 
import {
  FileText,
  Clock3,
  Target,
  AlertTriangle,
  Sparkles,
  TrendingUp,
} from "lucide-react";
 
import { useTheme } from "../css/ThemeContext";
import "./TheoryAnalytics.css";
import axios from "axios";
 
const TheoryAnalytics = () => {
 
  const { theme, generateGradient } = useTheme();
 
  const appGradient = generateGradient(
    theme.appGradient.start,
    theme.appGradient.end
  );
 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasData, setHasData] = useState(true); // Add this state
  const [message, setMessage] = useState(""); // Add this state
 
  const [selectedExamData, setSelectedExamData] = useState(null);
  const [dropdownExams, setDropdownExams] = useState([]);
  const [topicMastery, setTopicMastery] = useState([]);
 
  const [strength, setStrength] = useState("");
  const [weakness, setWeakness] = useState(null);
 
  const [selectedExamId, setSelectedExamId] = useState(null);
 
  // ================= FORMAT TIME =================
 
  const formatTime = (seconds) => {
    if (!seconds) return "0m 0s";
 
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
 
    return `${mins}m ${secs}s`;
  };
 
  // ================= FETCH API =================
 
  const fetchAnalytics = async (examId = null) => {
 
    setLoading(true);
    setError(null);
    setHasData(true); // Reset to true by default
 
    try {
 
      let url = "/dashboard/theory-analytics/";
 
      if (examId) {
        url += `?exam_employee_id=${examId}`;
      }
 
      const response = await axios.get(url, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });
 
      const data = response.data;
 
      // Check if we have data or if it's an empty state
      if (data.hasData === false) {
        setHasData(false);
        setMessage(data.message || "No data available");
        setSelectedExamData(null);
        setDropdownExams(data.dropdown_exams || []);
        setTopicMastery([]);
        setStrength("");
        setWeakness(null);
        return;
      }
 
      // Normal data flow
      setHasData(true);
      setMessage("");
      setSelectedExamData(data.selectedExam);
      setDropdownExams(data.dropdown_exams || []);
      setTopicMastery(data.topicMastery || []);
      setStrength(data.strength || "");
      setWeakness(data.weakness);
 
      // sync dropdown
      if (!examId && data.selectedExam?.exam_employee_id) {
        setSelectedExamId(
          data.selectedExam.exam_employee_id
        );
      } else if (examId) {
        setSelectedExamId(examId);
      }
 
    } catch (err) {
      console.error("ObjectiveAnalytics fetch error:", err);
      setError(err.message);
      setHasData(false);
    } finally {
      setLoading(false);
    }
  };
 
  // ================= INITIAL LOAD =================
 
  useEffect(() => {
    fetchAnalytics();
  }, []);
 
  // ================= DROPDOWN =================
 
  const handleExamChange = (e) => {
    const newExamId = e.target.value;
    if (newExamId) {
      fetchAnalytics(newExamId);
    }
  };
 
  // ================= LOADING =================
 
  if (loading) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
        }}
      >
        Loading analytics...
      </div>
    );
  }
 
  // ================= ERROR (Actual errors only) =================
 
  if (error) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          color: "red",
        }}
      >
        Error: {error}
      </div>
    );
  }
 
  // ================= NO DATA STATE =================
 
  if (!hasData || !selectedExamData) {
    return (
      <div className="theory-empty-state">
        <div className="empty-state-content">
          <div className="empty-icon">📚</div>
          <h3>No Objective Assessment Data Available</h3>
          <p>{message || "Complete an objective assessment to see your performance analytics here."}</p>
        </div>
      </div>
    );
  }
 
  // ================= SCORE =================
 
  const accuracy = selectedExamData.accuracy || 0;
 
  const circumference = 2 * Math.PI * 42;
 
  const strokeDashoffset =
    circumference * (1 - accuracy / 100);
 
  // ================= RESULT =================
 
  const resultText =
    selectedExamData.is_passed
      ? "Passed"
      : "Not passed";
 
  const resultColor =
    selectedExamData.is_passed
      ? "#22c55e"
      : "#ef4444";
 
  // ================= DYNAMIC HEADER =================
 
  let dynamicTitle = "";
  let dynamicMessage = "";
 
  // EXCELLENT
  if (accuracy >= 90) {
    dynamicTitle = "Outstanding performance 🚀";
    dynamicMessage =
      "Excellent work! Your accuracy and consistency are impressive.";
  }
  // VERY GOOD
  else if (accuracy >= 75) {
    dynamicTitle = "Great job 👏";
    dynamicMessage =
      "You're performing really well. A little more practice can make it perfect.";
  }
  // GOOD
  else if (accuracy >= 60) {
    dynamicTitle = "Good progress 📈";
    dynamicMessage =
      "You have a solid understanding. Focus on weaker areas to improve further.";
  }
  // AVERAGE
  else if (accuracy >= 40) {
    dynamicTitle = "Keep improving 💡";
    dynamicMessage =
      "You're getting there. More focused revision will boost your score.";
  }
  // LOW
  else {
    dynamicTitle = "Let's level up 🔥";
    dynamicMessage =
      "A focused review and consistent practice will turn this around quickly.";
  }
 
  // ================= FALLBACK STRENGTH =================
 
  let fallbackStrength = "";
  let fallbackWeakness = "";
 
  // EXCELLENT
  if (accuracy >= 90) {
    fallbackStrength =
      "Excellent performance with strong conceptual understanding and accuracy.";
    fallbackWeakness =
      "Very minor improvements needed — focus on maintaining this consistency.";
  }
  // VERY GOOD
  else if (accuracy >= 75) {
    fallbackStrength =
      "Strong overall performance with good accuracy across most topics.";
    fallbackWeakness =
      "A little more attention to tricky questions can further improve results.";
  }
  // GOOD
  else if (accuracy >= 60) {
    fallbackStrength =
      "Good understanding of core concepts and steady performance.";
    fallbackWeakness =
      "Focus more on weak areas and accuracy under challenging questions.";
  }
  // AVERAGE
  else if (accuracy >= 40) {
    fallbackStrength =
      "You have started building a solid foundation in the subject.";
    fallbackWeakness =
      "More revision and practice are needed to improve confidence and accuracy.";
  }
  // LOW
  else {
    fallbackStrength =
      "Good effort in attempting the assessment and engaging with the questions.";
    fallbackWeakness =
      "Focus on understanding the basics and revisit important concepts carefully.";
  }
 
  return (
 
    <div
      className="theory-analytics-wrapper"
      style={{
        "--app-gradient": appGradient,
      }}
    >
 
      {/* ================= HEADER ================= */}
 
      <div className="gradient-header">
 
        {/* LEFT SIDE */}
 
        <div className="header-left">
 
          <div className="small-text">
            {selectedExamData.title}
          </div>
 
          <h2>
            {dynamicTitle}
          </h2>
 
          <p>
            {selectedExamData.user_name} · {dynamicMessage}
          </p>
 
          {/* ================= PILLS ================= */}
 
          <div className="pill-row">
 
            <span className="pill">
              <FileText size={15} />
              {selectedExamData.attempted_count}/
              {selectedExamData.question_count} Attempted
            </span>
 
            <span className="pill">
              <Clock3 size={15} />
              {formatTime(
                selectedExamData.time_taken_seconds
              )}
            </span>
 
            <span className="pill green">
              <Target size={15} />
              {selectedExamData.correct_count} Correct
            </span>
 
            <span className="pill red">
              <AlertTriangle size={15} />
              {selectedExamData.wrong_count} Wrong
            </span>
 
          </div>
        </div>
 
        {/* ================= RIGHT SIDE ================= */}
 
        <div className="header-right">
 
          {/* DROPDOWN */}
 
          <select
            className="exam-dropdown"
            value={selectedExamId || ""}
            onChange={handleExamChange}
          >
 
            {dropdownExams.map((exam) => (
 
              <option
                key={exam.value}
                value={exam.value}
              >
                {exam.label}
              </option>
 
            ))}
 
          </select>
 
          {/* SCORE + RESULT */}
 
          <div className="score-result-container">
 
            {/* SCORE */}
 
            <div className="score-circle">
 
              <svg
                viewBox="0 0 100 100"
                className="circle-svg"
              >
 
                <circle
                  cx="50"
                  cy="50"
                  r="42"
                  className="circle-bg"
                />
 
                <circle
                  cx="50"
                  cy="50"
                  r="42"
                  className="circle-progress"
                  style={{
                    strokeDasharray: circumference,
                    strokeDashoffset:
                      strokeDashoffset,
                  }}
                />
 
              </svg>
 
              <div className="circle-content">
 
                <div>
                  {accuracy}%
                </div>
 
                <div className="label">
                  ACCURACY
                </div>
 
              </div>
            </div>
 
            {/* RESULT */}
 
            <div className="result-block">
 
              <div className="small-text">
                Result:
              </div>
 
              <div
                className="result-text"
                style={{
                  color: resultColor,
                }}
              >
                {resultText}
              </div>
 
              <div className="small-text">
 
                Threshold :
                {" "}
                {selectedExamData.required_percent}%
                required
 
              </div>
            </div>
          </div>
        </div>
      </div>
 
      {/* ================= TOPIC MASTERY ================= */}
 
      <div className="topic-card">
 
        <div className="topic-header">
 
          <h3>
            Areas to improve
          </h3>
 
          <p>
            Focus on these topics to improve your next Objective Performance
          </p>
 
        </div>
 
        <div className="topic-list">
 
          {topicMastery.length === 0 ? (
 
            <div className="all-mastered-card">
              🎉 Excellent work! You have mastered all topics in this assessment.
            </div>
 
          ) : (
 
            topicMastery.map((topic, idx) => {
 
              const percent = Math.round(
                (topic.correct / topic.total) * 100
              );
 
              const color =
                percent >= 80
                  ? "#22c55e"
                  : percent >= 50
                    ? "#f59e0b"
                    : "#ef4444";
 
              return (
 
                <div
                  key={idx}
                  className="topic-item"
                >
 
                  <div className="topic-row">
 
                    <span className="topic-name">
                      {topic.name}
                    </span>
 
                    <span
                      className="topic-badge"
                      style={{
                        background: `${color}22`,
                        color,
                      }}
                    >
                      {percent}%
                    </span>
 
                  </div>
 
                  <div className="topic-meta">
 
                    {topic.correct}/{topic.total}
                    {" "}
                    questions correct
                  </div>
 
                  <div className="topic-advanced-progress">
                    <div className="topic-performance-bar">
                      <div
                        className="topic-performance-fill"
                        style={{
                          width: `${percent}%`,
                          background: `linear-gradient(90deg, ${color}, ${color}cc)`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
 
      {/* ================= INSIGHTS ================= */}
 
      <div className="insight-grid">
 
        {/* STRENGTH */}
 
        <div
          className="summary-card"
          style={{
            background: "#e6f7ee",
            border: "1px solid #bbf7d0",
          }}
        >
 
          <div className="summary-icon strength-icon">
            <Sparkles size={18} />
          </div>
 
          <div>
 
            <div className="summary-title">
              What you did well
            </div>
 
            <div
              className="summary-text"
              style={{
                color: "#065f46",
              }}
            >
              {strength || fallbackStrength}
            </div>
 
          </div>
        </div>
 
        {/* WEAKNESS */}
 
        <div
          className="summary-card"
          style={{
            background: "#f5f3ff",
            border: "1px solid #e9d5ff",
          }}
        >
 
          <div className="summary-icon weakness-icon">
            <TrendingUp size={18} />
          </div>
 
          <div>
 
            <div className="summary-title">
              Where to grow
            </div>
 
            <div
              className="summary-text"
              style={{
                color: "#6b21a8",
              }}
            >
              {weakness || fallbackWeakness}
            </div>
 
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default TheoryAnalytics;

